export default {
  banks(state) {
    return state.banks
  },
};
